import httpClient from '../../../../shared/services/http/http-client';
import { IEmailCampaign, IPostEmailCampaign } from './email-campaign.model';

export default class EmailCampaignService {
  http;

  constructor() {
    this.http = httpClient
  }

  async createEmailCampaign(emailCampaign: IPostEmailCampaign): Promise<IPostEmailCampaign> {
    return this.http.post('/email-campaign/create', emailCampaign)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async getAllEmailCampaigns(queryString?: string): Promise<IEmailCampaign[]> {
    return this.http.get(`/email-campaign${queryString ? queryString : ''}`)
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async getAllEmailCampaignsWithPagination(reportPeriodId: string, campaignType: string, page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IEmailCampaign[] }> {
    return this.http.get(`email-campaign?reportPeriodId=${reportPeriodId}&campaignType=${campaignType}&page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err)
        throw err;
      });
  }

  async getOneEmailCampaign(id: string): Promise<IEmailCampaign> {
    return this.http.get(`/email-campaign/${id}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async editEmailCampaign(id: string, updatedEmailCampaign: Partial<IPostEmailCampaign>): Promise<IPostEmailCampaign> {
    return this.http.patch(`/email-campaign/${id}/update`, updatedEmailCampaign)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async deactivateEmailCampaign(id: string): Promise<any> {
    return this.http.post(`/email-campaign/${id}/disable`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async activateEmailCampaign(id: string): Promise<any> {
    return this.http.post(`/email-campaign/${id}/activate`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async sendTestEmail(id: string, emailToAddress: string): Promise<any> {
    return this.http.post(`/email-campaign/${id}/send-test-email`, { email: emailToAddress })
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }

  async getCampaignAnalytics(id: string, queryString: string): Promise<any> {
    return this.http.get(`/email-campaign/${id}/analytics${queryString}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err
      });
  }
}